/** The slice of hast this transform needs; typed structurally, as in `message-markdown-highlight.ts`. */
interface HastNodeLike {
  type: string;
  tagName?: string;
  value?: string;
  properties?: Record<string, unknown> | null;
  children?: HastNodeLike[];
}

function replaceImages(node: HastNodeLike, insideLink: boolean): void {
  const children = node.children;
  if (!Array.isArray(children)) return;

  node.children = children.map((child) => {
    if (child.type !== "element") return child;
    if (child.tagName !== "img") {
      replaceImages(child, insideLink || child.tagName === "a");
      return child;
    }
    const src = typeof child.properties?.src === "string" ? child.properties.src : "";
    const alt = typeof child.properties?.alt === "string" ? child.properties.alt : "";
    const label: HastNodeLike = { type: "text", value: alt || src };
    if (insideLink || !src) return label;
    return { type: "element", tagName: "a", properties: { href: src }, children: [label] };
  });
}

/**
 * Renders no Markdown image: each becomes a link to it, or, inside a link, just its alt text so
 * the link keeps its one destination. A loaded image requests its URL with no click, so content
 * written by a model or an uploaded file could otherwise carry data out in the query string.
 */
export function rehypeImagesAsLinks() {
  return (tree: unknown) => {
    if (!tree || typeof tree !== "object") return;
    replaceImages(tree as HastNodeLike, false);
  };
}
